import { Injectable } from '@angular/core';

@Injectable()
export class SurveyPreviewGenerationCoordinator {
  private activeGeneration = 0;

  activateNextGeneration(): number {
    this.activeGeneration += 1;
    return this.activeGeneration;
  }

  isActive(generation: number): boolean {
    return generation === this.activeGeneration;
  }
}
